export const state = {
  tables: [],
}

const getRowsPerPage = () => {
  const item = localStorage.getItem('rowsPerPage')
  return Number(item) || null
}

export const getters = {
  get: state => name => {
    const table = JSON.parse(localStorage.getItem(name)) || null
    let result = table || null
    const rowsPerPage =
      result && result.rowsPerPage ? result.rowsPerPage : getRowsPerPage()
    if (rowsPerPage && !result) result = { rowsPerPage }
    if (result && rowsPerPage)
      result = {
        ...result,
        rowsPerPage,
      }
    return result
  },
}

export const mutations = {
  SET(state, { name, pagination }) {
    localStorage.setItem(name, JSON.stringify(pagination))
  },
}

export const actions = {
  saveRowsPerPage({ state }, payload) {
    const current = localStorage.getItem('rowsPerPage')
    if (current === payload) return
    localStorage.setItem('rowsPerPage', payload)
  },
}
